import axios from 'axios';

const hostName = window.location.hostname;
let url = 'https://fmedway.com.br/wp-json/acf/v3/';

switch (hostName) {
  case 'cursos.medway.com.br':
    url = 'https://cursos.medway.com.br/wp-json/acf/v3/';
    break;
  default:
    break;
}

const apiCursos = axios.create({
  baseURL: url,
});

export default apiCursos;
